import { render, staticRenderFns } from "./delivery-zone-form.vue?vue&type=template&id=3db6e85a&scoped=true"
import script from "./delivery-zone-form.vue?vue&type=script&lang=js"
export * from "./delivery-zone-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6e85a",
  null
  
)

export default component.exports